import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "图层_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-351"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.466 4.23a.308.308 0 0 0-.08.01 3.072 3.072 0 0 1-.806.108 3.203 3.203 0 0 1-1.06-.184A3.183 3.183 0 0 1 11.492.378a.289.289 0 0 0-.272-.363.278.278 0 0 0-.104.02 3.546 3.546 0 0 0-2.21 3.095 4.932 4.932 0 0 1 .99.294 2.56 2.56 0 0 1 .54-1.672 4.416 4.416 0 0 0 .165.707 4.165 4.165 0 0 0 2.59 2.649 4.315 4.315 0 0 0 .846.204 2.58 2.58 0 0 1-.239.163 3.572 3.572 0 0 1 .823.642 3.553 3.553 0 0 0 1.12-1.504.286.286 0 0 0-.275-.384zm-3.438 1.356a2.926 2.926 0 0 0-.37.037 4.364 4.364 0 0 0-7.316 0 2.927 2.927 0 0 0-.37-.037 2.972 2.972 0 1 0 1.16 5.709 4.302 4.302 0 0 0 5.735 0 2.972 2.972 0 1 0 1.16-5.709zm0 4.944a1.959 1.959 0 0 1-.77-.156 1 1 0 0 0-1.05.168 3.303 3.303 0 0 1-4.417 0 1 1 0 0 0-1.05-.168 1.972 1.972 0 1 1-.769-3.788 1.08 1.08 0 0 1 .15.017l.095.013a1 1 0 0 0 .962-.445 3.364 3.364 0 0 1 5.642 0 1 1 0 0 0 .962.445l.095-.013a1.077 1.077 0 0 1 .15-.017 1.972 1.972 0 1 1 0 3.944zM7.02 15a1 1 0 0 0 2 0 6.605 6.605 0 0 0-1-2 6.605 6.605 0 0 0-1 2z",
  class: "cls-1"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.967 14.015a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2zm6.028 0a1 1 0 0 0 2 0 6.604 6.604 0 0 0-1-2 6.604 6.604 0 0 0-1 2z",
  class: "cls-1"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }